export default "__VITE_ASSET__DAux5_Tg__"